"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEService = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BLEUUID_1 = require("./BLEUUID");
/**
 * BLE Service
 */
let BLEService = class BLEService {
    constructor(uuid, data) {
        this.uuid = uuid;
        this.data = data;
    }
};
exports.BLEService = BLEService;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", BLEUUID_1.BLEUUID)
], BLEService.prototype, "uuid", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Uint8Array)
], BLEService.prototype, "data", void 0);
exports.BLEService = BLEService = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [BLEUUID_1.BLEUUID, Uint8Array])
], BLEService);
//# sourceMappingURL=BLEService.js.map